const page = {
  displayField: 'title',
  name: 'Page',
  description: 'Page builder page',
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'slug',
      name: 'Slug',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'headerType',
      name: 'Header Type',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [ { in: [ 'None', 'Only Logo', 'Full Navigation' ] } ],
      defaultValue: { 'en-US': 'Full Navigation' },
      disabled: false,
      omitted: false
    },
    {
      id: 'footerType',
      name: 'Footer Type',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [ { in: [ 'None', 'Full Navigation' ] } ],
      defaultValue: { 'en-US': 'Full Navigation' },
      disabled: false,
      omitted: false
    },
    {
      id: 'category',
      name: 'Category',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'category' ] } ],
        linkType: 'Entry'
      }
    },
    {
      id: 'heroImg',
      name: 'Hero Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkMimetypeGroup: [ 'image' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'metaTitle',
      name: 'Meta Title',
      type: 'Text',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'metaDescription',
      name: 'Description',
      type: 'Text',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'openGraphImage',
      name: 'Open Graph Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkMimetypeGroup: [ 'image' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'schema',
      name: 'Schema',
      type: 'Text',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'showStickyCta',
      name: 'Show Sticky CTA',
      type: 'Boolean',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true
    },
    {
      id: 'contentBlocks',
      name: 'Content Blocks',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [
          {
            linkContentType: [
              'advisorGrid',
              'shopGrid',
              'shopGridCarousel',
              'shortTextAndImage',
              'siteFooter',
              'video',
              'videoGallery',
              'bigPictureCta',
              'stackedTextImageBlock',
              'stackedTextImageCard',
              'textAndImageBlock',
              'variantStackedTextImageBlock',
              'neighborhood',
              'flexCollar',
              'introTextBlock',
              'searchHero',
              'template',
              'listingHighlights',
              'interiorHero',
              'threeColumn',
              'blogGrid',
              'threeColumnContent',
              'wideTextImage',
              'blogHomepageFeaturedArticles',
              'BlogHomepageAllArticles',
              'blogHomepageAllArticles',
              'shopNewestListings',
              'featuredPropertiesByLifestyle',
              'WideStackedTextImageBlock',
              'threeColumnTeams',
              'clientTestimonials',
              'contactForm',
              'statBlock',
              'articleHero',
              'PressReleaseArticleHero',
              'valuePropCarousel',
              'jazzHr',
              'neighborhoodCardGrid',
              'developmentCard',
              'richText'
            ]
          }
        ],
        linkType: 'Entry'
      }
    }
  ],
  metadata: {
    annotations: {
      ContentType: [
        {
          sys: {
            id: 'Contentful:AggregateRoot',
            type: 'Link',
            linkType: 'Annotation'
          }
        }
      ]
    }
  },
  sys: { id: 'page', version: 120, updatedAt: '2023-08-03T15:54:51.551Z' }
};
export default page;